
import * as handlebars_family from "../../handlebars_family.ts";
import "../../widget/form/required.ts";
const TPL = handlebars_family.addTemplate("modal/part/invitation_email",{"1":function(container,depth0,helpers,partials,data) {
    return "disabled";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<label> "
    + ((stack1 = lookupProperty(helpers,"i18n").call(depth0 != null ? depth0 : (container.nullContext || {}),"labels.email",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":1,"column":8},"end":{"line":1,"column":33}}})) != null ? stack1 : "")
    + " <input type=\"text\" name=\"email\" value=\""
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"token") : depth0)) != null ? lookupProperty(stack1,"email") : stack1), depth0))
    + "\" "
    + ((stack1 = lookupProperty(helpers,"unless").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"editable") : depth0),{"name":"unless","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":90},"end":{"line":1,"column":129}}})) != null ? stack1 : "")
    + " maxlength=\"250\" placeholder=\"\" data-widget=\"widget/form/required\" /></label>";
},"useData":true});
export default TPL;